import { retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EnviromentGlobalService } from './../../../../../../../shared/services/enviroment-global.service';
import { HttpErrorHandler } from 'src/app/shared/services/handle-error.service';
import { HttpClient } from '@angular/common/http';
import { ResponseServiceModel } from './../../../../../../../shared/models/response-service.model';
import { RNTFuncionarioEntry } from './../../../../../../../shared/entrys/rnt-funcionario.entry';
import { RequestCRUD } from 'src/app/shared/services/abstract/request-crud.service';
import { Injectable } from '@angular/core';

@Injectable()
export class ActualizarRegistrosService
  implements RequestCRUD<RNTFuncionarioEntry, ResponseServiceModel>{

  private API_URL;
  private Url: string;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandler,
    private enviromentGlobalService: EnviromentGlobalService
  ) {
    this.API_URL = enviromentGlobalService.apiUrl;
  }


  get(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  update(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  create(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  delete(entry: RNTFuncionarioEntry): Observable<ResponseServiceModel> {
    throw new Error("Method not implemented.");
  }

  getInformacionBasica(entry: any): Observable<ResponseServiceModel> {
    return this.http.post<ResponseServiceModel>(
      `${this.API_URL}/RegistroPrestador/ObtenerInfoGeneralP`, entry);
  }

  getSubcategoria(id: number): Observable<ResponseServiceModel> {

    this.Url = `${this.API_URL}/Subcategoria/PorCategoria/`;
    return this.http.get<ResponseServiceModel>(this.Url + id);
  }

  getSubcategoriaPorEstablecimiento(entry: any): Observable<ResponseServiceModel> {
    this.Url = `${this.API_URL}/Subcategoria/DisponiblesPorEstablecimiento`;
    return this.http.post<ResponseServiceModel>(this.Url, entry);
  }

  updateInfGeneral(entry: any): Observable<ResponseServiceModel> {
    this.Url = `${this.API_URL}/RegistroPrestador/UpdateRegistroInfoGeneralP`;
    return this.http.put<ResponseServiceModel>(this.Url, entry);
  }

  sincronizarEnSolicitud(entry: any): Observable<ResponseServiceModel> {
    return this.http
         .post<ResponseServiceModel>( `${this.API_URL}/RegistroPrestador/SincronizarRegistroE`, entry)
      .pipe(retry(2));
  }

}
